import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchClientSearch } from "./clientsearch.api";
import { keys } from "./keys";

export const useClientSearch = () => {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: fetchClientSearch,
        onSuccess: (data, params) => {
            qc.setQueryData(keys.clientSearch.results(params), data);
        }
    });
};
